
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class MapMarkerIcon extends Vue {
  @Prop({ default: true }) filled!: boolean;
}
